import ctl from '@netlify/classnames-template-literals'
import { useEffect, useRef } from 'react'
import { useInvisibleInput } from '../support'
import { isMac } from '../support/platform'
import { FilterBox, FilterBoxTheme } from './filter-box'
import { SearchIcon } from './filter-icons'

export type SearchFilterProps = {
	value: string
	onChange: (value: string) => void
	placeholder?: string
	theme?: FilterBoxTheme
	showShortcut?: boolean
}

export function SearchFilter({ value, onChange, placeholder, theme, showShortcut = false }: SearchFilterProps) {
	const invisibleInputClassName = useInvisibleInput()
	const inputRef = useRef<HTMLInputElement>(null)

	useEffect(() => {
		if (!showShortcut) { return }

		const handleKeyDown = (e: KeyboardEvent) => {
			if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
				e.preventDefault()
				inputRef.current?.focus()
			}
		}

		document.addEventListener('keydown', handleKeyDown)
		return () => document.removeEventListener('keydown', handleKeyDown)
	}, [showShortcut])

	return (
		<FilterBox icon={<SearchIcon />} theme={theme}>
			<div className="flex items-center w-full">
				<input
					ref={inputRef}
					type="text"
					placeholder={placeholder}
					value={value}
					onChange={(e) => onChange(e.target.value)}
					className={ctl(`rounded-md text-sm p-2 flex-1 min-w-0 ${invisibleInputClassName}`)}
				/>
				{showShortcut && (
					<div className="shrink-0 pr-2">
						<kbd className="hidden sm:inline-flex items-center gap-0.5 px-1.5 py-0.5 text-xs font-medium text-grey-500 bg-grey-100 rounded border border-grey-200">
							{isMac
								? (
									<>
										<span className="text-[10px]">⌘</span>K
									</>
								)
								: (
									'Ctrl+K'
								)}
						</kbd>
					</div>
				)}
			</div>
		</FilterBox>
	)
}
